export const cleanHtmlForPreview = (html, maxLength = 100) => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const text = div.textContent || div.innerText || "";
  return `${text.replace(/\s+/g, " ").trim().slice(0, maxLength)}...`;
};

// Matches real block/inline markup so we can tell HTML emails apart from plain text.
const HTML_MARKUP_REGEX =
  /<\/?(?:p|br|div|ul|ol|li|a|strong|b|em|i|u|span|table|tr|td|th|tbody|thead|blockquote|h[1-6]|img|pre|hr|font)\b[^>]*>/i;

/**
 * Whether a string already contains HTML markup (vs. plain text).
 * @param {string} content
 * @returns {boolean}
 */
export const isHtmlContent = content =>
  typeof content === "string" && HTML_MARKUP_REGEX.test(content);

/**
 * Prepares email content for rendering via dangerouslySetInnerHTML.
 * - HTML content is returned as-is so its own block elements control spacing.
 *   (Converting its newlines to <br/> injects spurious blank lines between
 *   <p>/<li> tags — the root cause of the email formatting issue.)
 * - Plain-text content keeps its paragraphing by converting line breaks to <br/>.
 * @param {string} content
 * @returns {string}
 */
export const formatEmailBodyHtml = content => {
  if (!content || typeof content !== "string") return "";
  // parseEmailReply prefixes a leading "\n"; drop it before checking/rendering.
  const trimmed = content.replace(/^\n+/, "");
  if (isHtmlContent(trimmed)) return trimmed;
  return trimmed.replace(/\n{2,}/g, "<br/><br/>").replace(/\n/g, "<br/>");
};

/**
 * Scrolls the window to the top of the page with optional smooth behavior
 * @param {boolean} smooth - Whether to use smooth scrolling (default: true)
 * @param {number} top - The vertical position to scroll to (default: 0)
 */
export const scrollToTop = (smooth = true, top = 0) => {
  window.scrollTo({
    top,
    left: 0,
    behavior: smooth ? "smooth" : "auto",
  });
};
